<e-list header="Gebruikers" search [(searchText)]="filterSearchText">
  <ng-container slot="header">
    <div class="d-flex" style="width: 100%; gap: var(--spacing-2)">
      <ng-select
        [(ngModel)]="selectedNonMember"
        style="width: 250px"
        placeholder="Gebruiker toevoegen..."
        >
        @for (user of nonMembers$ | async; track user) {
          <ng-option [value]="user">{{
            user.displayName
          }}</ng-option>
        }
      </ng-select>
      <button
        class="mgmt-add-btn"
        squared
        size="sm"
        eBtn
        color="primary"
        icon="user-plus"
        [disabled]="!selectedNonMember"
        (click)="addMember(selectedNonMember)"
      ></button>
    </div>
  </ng-container>

  @for (member of groupMembers$ | async | filter : filterSearchText; track member) {
    <e-collapsible-list-item
      class="animate__animated animate__fadeIn"
      [opened]="member.is(selectedMember)"
      (click)="selectedMember = member"
      [active]="member.is(selectedMember)"
      [class.highlight-filter]="member.is(filteredUser)"
      clickable
      actionsOnHover
      >
      <ng-container slot="below-title">
        <div class="member-card-head">
          <span class="member-avatar">{{ initials(member) }}</span>
          <span class="member-name">{{ member.displayName }}</span>
        </div>
      </ng-container>
      <ng-container slot="actions">
        <button
          eBtn
          color="highlight"
          iconColor="danger"
          squared
          (click)="removeMember(member)"
          icon="user-minus"
        ></button>
      </ng-container>
    </e-collapsible-list-item>
  }
</e-list>
